module.exports = __webpack_public_path__ + "img/cover.ce83483e.jpg";